import ResumeContainer from './resume_container';

const Resume = ResumeContainer;
export default Resume;
